import { render, staticRenderFns } from "./paragraphBlock.vue?vue&type=template&id=b42b1ee2&scoped=true"
import script from "./paragraphBlock.vue?vue&type=script&lang=js"
export * from "./paragraphBlock.vue?vue&type=script&lang=js"
import style0 from "./paragraphBlock.vue?vue&type=style&index=0&id=b42b1ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42b1ee2",
  null
  
)

export default component.exports